import { history } from 'Store';
import { routes } from 'Constants/routes';

export const info = {
  title: 'Dg.calculate.notification.title',
  description: 'Dg.calculate.notification.description',
  buttonLabel: 'Dg.firstStep.notification.button',
  buttonClick: (): void => history.push(routes.DATAGATHERING_HELP),
};

export const validateDate = (date: string): boolean => {
  const formatDate = /^\d{2}\/\d{2}\/\d{4}$/;
  if (!formatDate.test(date)) return false;

  const [day, month, year] = date.split('/').map(Number);
  const dateObject = new Date(year, month - 1, day);
  return (
    dateObject.getDate() === day &&
    dateObject.getMonth() === month - 1 &&
    dateObject.getFullYear() === year &&
    year >= 1900 && // Validamos que el año sea razonable
    year <= new Date().getFullYear() // No permitir fechas futuras
  );
};
